<template>
  <div class="lp-adm-drop-input-container">

    <!-- 셀렉터 -->
    <div class="selector-box unselect" @click.capture="clickSelector">
      <div>{{ finalText }}</div>
      <i class="material-icons">{{ isOpenSelector?'keyboard_arrow_up':'keyboard_arrow_down' }}</i>
    </div>
    <div class="drop-input-list-wrapper">
      <!-- 검색 -->
      <div class="drop-input-select-wrapper"
           :style="wrapperStyle" v-if="isOpenSelector">
        <input class="drop-input-input"
               type="text"
               :value="selectedLabel"
               @click.capture="isOpen=true"
               @input="searchKeyword"
               @focus="isOpen=true"
               @keyup.enter="onEnter"
               :placeholder="placeholder">
        <div class="drop-button">
          <img class="unselect" :src="svgSrc('u_search')" @click.stop.prevent="isOpen=!isOpen"
               v-if="!selectedLabel"
               style="width:15px;height:15px;margin-right:12px"/>
          <img class="unselect" :src="svgSrc('fi_close_outline')" @click.stop="removeTargetItem"
               v-if="selectedLabel"
               style="width:15px;height:15px;margin-right:12px"/>
        </div>
      </div>
      <!-- 리스트 -->
      <div>
        <div v-if="isOpen && list.length!==0"
             class="drop-input-list"
             :style="listStyle">
          <div class="drop-input-item"
               v-for="(item, idx) in list"
               :key="'sort-list'+idx">
            <div @click.stop.prevent="clickTargetItem(item)">
              <span>{{ labelName(item.label) }}</span></div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="isOpen && list.length>0 && isOpenSelector" class="lp-outsider-layout" @click="clickOutSider"></div>

  </div>
</template>

<script>
  export default {
    name: 'LpSelectorDropDown',
    // replace: 선택한 값으로 선정할 키값 ex)
    props: ['data', 'placeholder', 'width', 'listAlign', 'number_length', 'selectVal', 'added_field', 'replace'],
    data() {
      return {
        isOpenSelector: false,
        trigger: false,
        isOpen: false,
        selectedLabel: '',
        list: [],
        origin_list: [],
        test: [],
        //disabled: true
      }
    },
    created() {
      this.list = this.data;
      this.origin_list = this.cloneItem(this.data);

      this.init();
    },
    computed: {
      finalText() {
        let text = ''
        let item = find(this.origin_list, 'value', this.selectVal)
        if(item) text = item.name
        return text
      },
      wrapperStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        return style;
      },
      listStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        if (this.listAlign !== undefined) {
          style.textAlign = this.listAlign;
        }
        return style;
      }
    },
    watch: {
      data(n) {
        this.list = this.data;
        this.origin_list = this.cloneItem(this.data);
      },
      selectVal(n) {
        this.init();
      },
      /*selectedLabel(n) {
        if(n==='') {
          this.$emit('onSelect', {label:'', value:''});
        }
      }*/
    },
    methods: {
      clickSelector() {
        this.isOpenSelector=true
        this.isOpen=true
        this.selectedLabel = '';
        this.list = this.cloneItem(this.origin_list);
      },
      init() {
        let item = find(this.list, 'value', this.selectVal)
        if(item) this.selectedLabel = item.label;
      },
      onEnter(){
        // 인풋에서 엔터키 입력시, 목록중 첫번째 값 반영
        if(this.list.length>0) {
          this.clickTargetItem(this.list[0]);
        }

        this.isOpen=false;
        this.isOpenSelector=false;

      },
      labelName(label) {
        let full_text = '';
        let sep = label.split('/')
        for(let i=0; i<sep.length; i++){
          if(sep.length-1 > i) {
            full_text += sep[i] + '\n'
          }
          else full_text += sep[i]
        }
        return full_text;
      },
      // 바깥 쪽 선택시 값 원래되로 돌리기
      clickOutSider() {
        this.isOpen=false;
        this.isOpenSelector = false;
        /*this.selectedLabel = this.selectVal;
        this.list = [];

        for (let i = 0; i < this.data.length; i++) {
          this.list.push({
            label: this.data[i].label,
            value: this.data[i].value
          });
        }*/
      },
      searchKeyword(e) {
        this.selectedLabel = e.target.value;
        this.list = [];
        if(this.selectedLabel === '') {
          this.list = this.data;
        }
        else {
          for (let i = 0; i < this.data.length; i++) {
            // let reg = new RegExp('^' + this.selectedLabel);
            let isContain = this.data[i].label.toString().search(this.selectedLabel);

            if (isContain >-1) {
              if(!this.added_field){
                this.list.push({
                  label: this.data[i].label,
                  value: this.data[i].value
                });
              }
              else {
                let params = {
                  label: this.data[i].label,
                  value: this.data[i].value
                }
                if(this.added_field) {
                  params[this.added_field] = this.data[i][this.added_field];
                }
                this.list.push(params);
              }
            }
            if (this.selectedLabel.length > this.number_length) {
              this.selectedLabel = this.selectedLabel.substr(0, this.number_length);
            }
          }
        }
      },
      clickTargetItem(item) {
        this.selectedLabel = item.label;

        // name이 있을 경우 name 으로 바꿔서 넣음
        if (item.name) {
          this.selectedLabel = item.name;
        }
        // replace가 있을 경우 해당 키의 value값 라벨에 넣음
        if (this.replace!==undefined) {
          this.selectedLabel = item[this.replace]
        }
        this.isOpen = false;
        this.isOpenSelector = false;
        this.$emit('onSelect', item);
      },
      removeTargetItem() {
        this.selectedLabel = '';
        // this.$emit('onSelect', {label:'', value:''});
        this.searchKeyword({target:{value:''}});
      },
      onBlur() {
        if (this.trigger) {
          this.isOpen = false;
          this.isOpenSelector = false;
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .drop-down-close-button
    display none
    position absolute
    right 18px
    top 50%
    transform translate(0, -50%)
    font-size 18px
    cursor pointer
    user-select none
    z-index 100

  .drop-input-select-wrapper:hover > .drop-down-close-button
    display block

  .lp-adm-drop-input-container
    position relative
    font-weight 400

  @media (max-width:768px)
    .lp-adm-drop-input-container
      margin-bottom 12px

    .lp-adm-drop-input-container:last-child
      margin-bottom 0

  .drop-input-select-wrapper
    //box-shadow: inset 0 1px 2px rgba(10,10,10,0.1);
    //width 240px
    border 1px solid #ccc
    //border-radius 3px
    display flex
    align-items center
    background-color white

  .drop-input-input
    //box-shadow inset 0 1px 2px rgba(10, 10, 10, 0.1)
    width calc(100% - 17px)
    border none
    font-size .9rem
    padding 7px 12px
    /*padding-right 0*/
    padding-right 32px
    color #333
    outline none

  .drop-button
    text-align center

  .drop-input-arrow-icon
    font-size 1.2rem
    cursor pointer

  .drop-input-list
    list-style none
    margin 0
    padding 0
    background-color #f5f5f5
    border 1px solid #ddd
    border-top none
    //width calc(100% - 21px)
    /*height 192px*/
    width 100%
    max-height: 192px;
    overflow-y auto
    /*position absolute*/
    //top 31px
    /*top 67px*/
    /*left inherit*/
    /*z-index 11*/

  .drop-input-item
    font-size .9rem
    color #555
    /*height 36px*/
    /*line-height 36px*/
    cursor pointer
    white-space pre-line
    padding 6px 12px

  .drop-input-item:hover
    background-color #ddd

  // input placeholder style
  // .drop-input-input::-webkit-input-placeholder

  .lp-outsider-layout
    position fixed
    z-index 10
    top 0
    left 0
    right 0
    bottom 0

  .selector-box
    min-width 200px
    display flex
    justify-content space-between
    align-items center
    border 1px solid #cccccc
    border-radius 3px
    padding 4px 8px
    font-size 13px

  .drop-input-list-wrapper
    list-style none
    margin 0
    padding 0
    border-top none
    //width calc(100% - 21px)
    /*height 192px*/
    width 100%
    position absolute
    top 39px
    /*top 67px*/
    left inherit
    z-index 11
</style>
